import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { formatPrice, useStorage } from '../shared/utils/general.util';
import STORAGE_KEYS from '../shared/constants/storage';
import LOCAL_STORAGE_KEY from '../shared/constants/localStorageKey';
import { fetchSATLinkedById } from '../services/satLinking.service';
import { linkedAccount } from '../redux/slices/sat.slice';
import { ANALYTICS_EVENTS } from '../shared/constants/events';
import { PAYMENT_METHOD } from '../@types/Checkout.type';
import { useEffect } from 'react';
import { sendUserInteractionEvent } from '../services/user-interaction.service';
import { getMonthName } from '../shared/utils/dates.util';
import {
	PRODUCTS_SLUG,
	REGULARIZATION_REGARATION_PRODUCTS_SLUG,
} from '../shared/constants/SlugsProducts';

const useSuccessfulPurchaseEvent = () => {
	const dispatch = useDispatch();
	const taxPayer = useSelector((state: RootState) => state.taxProfile.taxPayer);
	const { dataLayer } = window as any;
	const userProfile = useSelector((state: RootState) => state.profile.user);
	const platformOS = useStorage().getItem(STORAGE_KEYS.PLATFORM_OS) ?? 'web';

	const storage = useStorage();
	const purchase = JSON.parse(
		storage.getItem(LOCAL_STORAGE_KEY.LAST_ORDER_PURCHASE) || '{}',
	);

	const { tokenSession } = useSelector((state: RootState) => state.auth);

	const isPaypal =
		new URLSearchParams(location.search).get('paymentMethod') ===
		PAYMENT_METHOD.PAYPAL;

	const fetchSatLinkedAcount = async () => {
		try {
			const resource = await fetchSATLinkedById(tokenSession);
			dispatch(linkedAccount(resource));
		} catch (error) {}
	};

	const trackingEventSuccessfulPurchase = async () => {
		const dataLayerProperties = {
			event: ANALYTICS_EVENTS.PURCHASE,
			phone: userProfile?.cellphone,
			rfc: taxPayer?.code ?? '',
			ecommerce: {
				transaction_id: purchase?.id,
				value: formatPrice(parseInt(purchase?.total!)),
				tax: (parseInt(purchase?.taxes!) ?? 0) / 100,
				currency: 'MXN',
				payment_method: isPaypal ? PAYMENT_METHOD.PAYPAL : PAYMENT_METHOD.CARD,
				coupon: purchase?.coupon?.code ?? '',
				Items: purchase?.shoppingItem?.map((item: any) => ({
					item_name: item?.productVersion?.product?.name,
				})),
			},
		};
		dataLayer.push({ ecommerce: null });
		dataLayer.push(dataLayerProperties);

		try {
			const regularizations =
				purchase?.shoppingItem?.filter((item: any) =>
					[
						REGULARIZATION_REGARATION_PRODUCTS_SLUG.REG_PT_TODAS_ACTIVIDADES,
						REGULARIZATION_REGARATION_PRODUCTS_SLUG.REG_RESICO_PLUS,
						PRODUCTS_SLUG.ANNUAL_DECLARATION_HARD,
						PRODUCTS_SLUG.ANNUAL_DECLARATION,
					].includes(item?.productVersion?.product?.slug),
				) ?? [];

			const eventProperties = {
				amount: parseInt(purchase?.total!) / 100,
				chargedId: purchase?.id!,
				paymentMethod: isPaypal ? PAYMENT_METHOD.PAYPAL : PAYMENT_METHOD.CARD,
				succed: true,
				coupon: purchase?.coupon?.code ?? '',
				Items: purchase?.shoppingItem?.map((item: any) => ({
					product_name: item?.productVersion?.product?.name,
					product_version_id:
						item?.productVersion?.product?.defaultProductVersionId,
					month: item?.additionalInformation?.month,
					month_name: getMonthName(item?.additionalInformation?.month, true),
					year: item?.additionalInformation?.year,
				})),
				periodsCovered: regularizations
					?.map(
						(item: any) =>
							`${getMonthName(item?.additionalInformation?.month, true)} ${item?.additionalInformation?.year}`,
					)
					?.join(', '),
				source: platformOS,
			};
			await sendUserInteractionEvent(
				userProfile?.id!,
				ANALYTICS_EVENTS.CHARGED,
				platformOS,
				eventProperties,
			);
		} catch (error) {}
	};

	useEffect(() => {
		fetchSatLinkedAcount();
	}, []);

	return {
		trackingEventSuccessfulPurchase,
		lastPurchase: purchase,
	};
};

export default useSuccessfulPurchaseEvent;
